import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import PanelWiseRateTab from './tabs/PanelWiseRateTab';

export const PanelRatePage = ({ showToast }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const initialPanelId = searchParams.get('panelId') ? parseInt(searchParams.get('panelId'), 10) : null;

  return (
    <div className="page-container fade-in">
      <div className="breadcrumb">
        <button type="button" onClick={() => navigate('/dashboard')}>
          Home
        </button>
        <span className="breadcrumb-divider">/</span>
        <button type="button" onClick={() => navigate('/masters')}>
          Masters
        </button>
        <span className="breadcrumb-divider">/</span>
        <button type="button" onClick={() => navigate('/masters/panels')}>
          Panel Master
        </button>
        <span className="breadcrumb-divider">/</span>
        <span className="breadcrumb-active">Panel-Wise Rates</span>
      </div>

      <div className="page-header" style={{ marginBottom: '1.5rem' }}>
        <div className="page-title-group">
          <h1 className="page-title">Panel-Wise Rate Configuration</h1>
          <span className="page-subtitle">
            Configure tariffs for Single Tests, Clinical Profiles, and Health Packages, view inheritance hierarchy, and execute bulk price revisions for Cash Panels.
          </span>
        </div>

        <div>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate('/masters/panels')}
            style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}
          >
            ← Back to Panel Master
          </button>
        </div>
      </div>

      <div className="glass-card fade-in" style={{ padding: '1.5rem' }}>
        <PanelWiseRateTab showToast={showToast} initialPanelId={initialPanelId} />
      </div>
    </div>
  );
};

export default PanelRatePage;
